import { noView } from 'aurelia-framework';
import settings from 'global.config.js';

@noView
export class WithUrlValueConverter {
	toView(value) {
		return `${settings.baseUrl}${value}`;
	}
}
